export { default } from './GoTurkiyeImage'
export type { GoTurkiyeImageProps, ImageLozenge } from './types'
